import React from "react";

import WelcomeContainer from "components/WelcomeContainer";
import Camera from "components/Camera";
import { useSelector } from "react-redux";
import Cookie from "universal-cookie";
import { useHistory } from "react-router-dom";
import Modal from "components/Modal";
import Countdown from "react-countdown";

const cookie = new Cookie();

export default function Welcome(props) {
  const general = useSelector((state) => state.general);
  const history = useHistory();
  const TOTAL_TIME = 30 * 60 * 1000;

  const getRemaining = () => {
    const startTime = cookie.get("start_time_bod2");
    if (!startTime) return TOTAL_TIME;
    const elapsed = Date.now() - parseInt(startTime);
    return Math.max(0, TOTAL_TIME - elapsed);
  };

  const clickAgree = () => {
    history.push("/bod2/assestment");
  };

  const handleTimeUp = () => {
    history.push("/bod2/assestment");
  };

  return (
    <div>
      <Modal token={props.token} profile={props.profile} />
      {general.on_cam && <Camera profile={props.profile} />}
      <WelcomeContainer
        key="bod2-case-a"
        ln="id"
        btnText="Mulai"
        clickAgree={clickAgree}
        welcomeMessage="Anda akan menjalani Situational Judgment Test (SJT) untuk posisi BOD-2. Perhatikan waktu pengerjaan Anda. Anda dapat sewaktu-waktu membuka kembali gambaran umum perusahaan dan petunjuk pengisian ini dengan mengklik di bagian kanan atas sebelah waktu."
        timerComponent={
          <div
            style={{
              backgroundColor: "#fff3cd",
              border: "1px solid #ffc107",
              borderRadius: 8,
              padding: "10px 16px",
              display: "flex",
              alignItems: "center",
              gap: 10,
              width: "50%",
              marginBottom: 8,
            }}
          >
            <span style={{ fontSize: 18 }}>⏱</span>
            <div
              style={{
                display: "flex",
                alignItems: "start",
                flexDirection: "column",
                justifyContent: "",
              }}
            >
              <span style={{ margin: 0, fontSize: 12, color: "#666" }}>
                Waktu pengerjaan sudah berjalan
              </span>
              <Countdown
                date={Date.now() + getRemaining()}
                onComplete={handleTimeUp}
                renderer={({ hours, minutes, seconds }) => (
                  <span
                    style={{
                      fontSize: 20,
                      fontWeight: "bold",
                      color: "#e53935",
                    }}
                  >
                    {hours > 0 ? `${String(hours).padStart(2, "0")}:` : ""}
                    {String(minutes).padStart(2, "0")}:
                    {String(seconds).padStart(2, "0")}
                  </span>
                )}
              />
            </div>
          </div>
        }
      >
        <div className="welcome-mobile">
          <h3 style={{ color: "#00abbd" }}>
            Gambaran umum perusahaan dan Petunjuk pengisian
          </h3>

          <p>
            PT Farmasi Nusantara merupakan perusahaan farmasi nasional yang
            berperan strategis dalam penyediaan produk farmasi dan biologis,
            termasuk dukungan terhadap program kesehatan nasional. Dalam
            menghadapi dinamika industri, perusahaan terus mendorong peningkatan
            efisiensi operasional, kualitas layanan, kepatuhan regulasi, serta
            penguatan kapabilitas organisasi agar tetap berkelanjutan dan
            kompetitif.
          </p>

          <p>
            Anda saat ini berperan sebagai <b>Kepala Departemen (BOD-2)</b> yang
            memegang peran penting dalam menerjemahkan kebijakan dan arahan
            strategis Divisi ke dalam keputusan dan tindakan operasional di
            tingkat departemen. Anda diharapkan mampu menyeimbangkan tuntutan
            kinerja jangka pendek dengan kepentingan jangka menengah–panjang,
            serta mengelola tim, proses, dan risiko secara profesional dan
            bertanggung jawab.
          </p>

          <p>
            Dalam tes ini, Anda akan dihadapkan pada sejumlah situasi kerja
            realistis yang mencerminkan tantangan manajerial di lingkungan PT
            Farmasi Nusantara. Setiap situasi diikuti oleh beberapa alternatif
            tindakan yang seluruhnya mungkin dilakukan, namun memiliki tingkat
            efektivitas yang berbeda.
          </p>

          <h4 style={{ marginTop: 20, color: "#78000F" }}>Tugas Anda:</h4>
          <p>Untuk setiap kasus yang disajikan:</p>
          <ul style={{ textAlign: "left", lineHeight: "1.8" }}>
            <li>
              <b>
                Pilih satu tindakan yang menurut Anda PALING TEPAT (
                <i>Best Action</i>)
              </b>
              <br />→ Tindakan yang paling mencerminkan efektivitas
              kepemimpinan, pertimbangan strategis, dan keselarasan dengan peran
              Kepala Departemen.
            </li>
            <li>
              <b>
                Pilih satu tindakan yang menurut Anda PALING TIDAK TEPAT (
                <i>Poor Action</i>)
              </b>
              <br />→ Tindakan yang paling lemah, berisiko, atau tidak sejalan
              dengan tuntutan peran dan konteks organisasi.
            </li>
          </ul>

          <h4 style={{ marginTop: 20, color: "#78000F" }}>Petunjuk Penting:</h4>
          <ul style={{ textAlign: "left", lineHeight: "1.8" }}>
            <li>
              Jawablah berdasarkan pertimbangan Anda terhadap apa yang
              seharusnya dilakukan dalam konteks profesional.
            </li>
            <li>
              Pertimbangkan dampak keputusan terhadap kinerja, risiko, tim,
              lintas fungsi, serta arah strategis perusahaan.
            </li>
            <li>
              Tidak ada jawaban benar atau salah secara absolut, namun pilihan
              Anda akan mencerminkan pola pengambilan keputusan dan tingkat
              kompetensi kepemimpinan.
            </li>
          </ul>

          <p style={{ marginTop: 20, fontStyle: "italic" }}>
            Kerjakan setiap kasus secara cermat dan konsisten, seolah-olah Anda
            benar-benar berada pada posisi tersebut di lingkungan kerja PT
            Farmasi Nusantara.
          </p>
        </div>
      </WelcomeContainer>
    </div>
  );
}
